/* eslint-disable jsx-a11y/anchor-is-valid */

import React, {Fragment} from "react";
import {
    ActiveLocales,
    ListTranslationsResponse,
    Translation
} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {RouteComponentProps, withRouter} from "react-router";
import {TranslationsService} from "../../services/TranslationsService";
import {LoadingViewState, RouterView} from "../RouterView";
import {EditTranslation} from "./EditTranslation";
import {AddTranslationKeyForm} from "./AddTranslationKeyForm";



interface Props extends RouteComponentProps {

}
interface State extends LoadingViewState {
    locales? : string[];
    defaultLocale? : string;
    selectedLocale? : string;
    localeTranslations? : LocaleTranslations[];
    loadingTranslations? : boolean;
    showOnlyMissing?: boolean;
    newLocale?: string;
}

interface LocaleTranslations {
    locale: string;
    translations : Translation[];
}
export class CasinoCategoryListView extends RouterView<Props, State> {



    service : TranslationsService;

    constructor(props : Props){
        super(props);
        this.state = { locales : [], localeTranslations : [], loadingTranslations : false, showOnlyMissing : false, newLocale : ""};
        this.service = getContainer().getTranslationsService();
    }

    getTitle(): string {
        return "Translations";
    }

    loadContent(): Promise<any> | void {
        return this.service.getLocales().then((locales : ActiveLocales)  => {
            let locale = locales.defaultLocale;
            this.setState({ locales : locales.locales, defaultLocale : locale, selectedLocale : locale})
            if(locale) {
                return this.fetchTranslations(locale);
            } else {
                return Promise.reject();
            }
        })
    }
    fetchTranslations(locale : string, skipLoadingProgress? : boolean) {
        this.setState({ loadingTranslations : skipLoadingProgress ? false : true});
        return this.service.list({ locale : locale, offset: 0, limit : 1000})
            .then(( resp : ListTranslationsResponse) => {
                if(!this.state.localeTranslations || !resp.items) {
                    return Promise.resolve();
                }
                let localeTrans : LocaleTranslations[] = this.state.localeTranslations;

                localeTrans = localeTrans.concat().filter(t => t.locale !== locale);
                localeTrans.push({ locale : locale, translations : resp.items});
                this.setState({ localeTranslations : localeTrans, loadingTranslations : false, selectedLocale : locale});
            });
    }
    changeLocale(locale?: string) {
        if(locale) {
            this.fetchTranslations(locale);
        }
    }
    onUpdate(t : Translation) {
        if(t.locale) {
            this.fetchTranslations(t.locale, true);
        }
    }

    onKeyAdded() {
        if(this.state.defaultLocale) {
            this.fetchTranslations(this.state.defaultLocale);
        }
    }
    addLocale() {

        if(this.state.locales && this.state.newLocale && this.state.newLocale.trim().length >= 2) {
            let locales =  this.state.locales.concat();
            
            if(this.state.locales.find(l => l === this.state.newLocale)) {
                console.log("Trying to add locale " + this.state.newLocale + " that already exist");
                return;
            }
            locales.push(this.state.newLocale);

            this.setState({ locales : locales, newLocale : ""});
        }
    }
    renderContent() {
        if(!this.state.locales || !this.state.localeTranslations || !this.state.selectedLocale) {
            return <span/>
        }
        let selectedTranslations  = this.state.localeTranslations.find(t => t.locale === this.state.selectedLocale);
        if(!selectedTranslations) {
            return <span />
        }
        let defaultTranslations = this.state.localeTranslations.find(t => t.locale === this.state.defaultLocale);
        if(!defaultTranslations) {
            return <span/>;
        }
        return (
            <Fragment>
                <div className={"card-box"}>
                    <h4>Show Locale</h4>
                    <div className={"form"}>
                        <div className={"form-group"}>
                            <select className={"form-control"} defaultValue={this.state.defaultLocale} onChange={(e)=>this.changeLocale(e.target.value)}>
                                {this.state.locales.map(l => <option key={l}>{l}</option>)}
                            </select>
                        </div>
                        <div className={"form-group form-check"}>
                            <input className={"checkbox"} id="showOnlyMissing"  type={"checkbox"} checked={this.state.showOnlyMissing} onChange={(e)=>this.setState({ showOnlyMissing : !this.state.showOnlyMissing})}/>
                            <label htmlFor={"showOnlyMissing"} className={"control-label"}>Show only missing translations </label>
                        </div>
                    </div>
                </div>
                <div className={"card-box"}>
                    <h4>Add Locale</h4>
                    <div className={"form form-inline"}>
                        <div className={"form-group form-check"}>
                            <input className={"form-control"} value={this.state.newLocale} type={"text"} onChange={(e)=>this.setState({ newLocale : e.target.value})} placeholder={"Eg: sv, zh-Hans"} />
                            <a  className={"btn btn-primary"} onClick={()=>this.addLocale()}>Add Locale</a>
                        </div>
                    </div>
                </div>
                <div className={"card-box"}>

                    { this.state.defaultLocale && this.state.defaultLocale === this.state.selectedLocale  &&  <AddTranslationKeyForm onAdded={()=>this.onKeyAdded()} locale={this.state.defaultLocale}/>}
                    { this.state.loadingTranslations && (
                        <div>Loading</div>
                    )}
                    { !this.state.loadingTranslations && (

                        <table className={"table table-striped"}>
                            <thead>
                            <tr>
                                <th>Key</th>
                                <th>Value</th>
                            </tr>
                            </thead>
                            <tbody>
                            {defaultTranslations &&  defaultTranslations.translations.map( t => {
                                if(!selectedTranslations) {
                                    return <tr></tr>
                                }
                                let translation = selectedTranslations.translations.find( (s : Translation)=> s.key === t.key);
                                if(this.state.showOnlyMissing && translation) {
                                    return false;
                                }

                                return (
                                  <Fragment>
                                      <tr key={t.id}>
                                          <td>{t.key}</td>
                                          <td>
                                              <EditTranslation translation={translation} locale={selectedTranslations.locale} akey={t.key} onUpdate={(t : Translation)=> this.onUpdate(t)}/>
                                              {!translation && (
                                                <span>{t.value}</span>
                                              )}
                                          </td>
                                      </tr>

                                  </Fragment>
                                )
                            })}
                            </tbody>
                        </table>
                    )}
                </div>
            </Fragment>
        );
    }





}

export default withRouter(CasinoCategoryListView);
